import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { selectPromotionalTipByUrl } from '../../db/app/selectors';
import { useAppSelector } from '../../store/hooks';

const usePromotionalTip = () => {
  const location = useLocation();

  const promotionalTip = useAppSelector((state) => selectPromotionalTipByUrl(state, location.pathname));

  const [isPromotionalTipPanelOpen, setIsPromotionalTipPanelOpen] = useState(false);

  const handlePromotionalTipClick = () => {
    setIsPromotionalTipPanelOpen(true);
  };

  const handleClosePromotionalTipPanel = () => {
    setIsPromotionalTipPanelOpen(false);
  };

  return {
    promotionalTip,
    isPromotionalTipPanelOpen,
    handlePromotionalTipClick,
    handleClosePromotionalTipPanel,
  };
};

export default usePromotionalTip;
